import { useEffect } from "react";
import { Badge } from "antd";
import { YhBox } from "@/components/YhBox";
import { useTasteModel } from "../tasteModel";
import { getBaseImgLookUrl } from "@/utils/constants";
import { IFoods } from "../tasteType";
import { tasteService } from "../tasteService";

export const MealBox = () => {

    const {
        dayMeal,
        selectMaterial,
        tasteList, setTasteList,
        setSelectMaterial,
        loadLibrary,
    } = useTasteModel();

    useEffect(() => {
        loadLibrary()
    }, [])

    //选中原材料获取对应菜单的菜品。
    const onMaterialType = async (material: IFoods, index: number) => {
        setSelectMaterial(material)
        let { retData } = await tasteService.statisByMenu(dayMeal.id);
        setTasteList((retData.foods ?? []).filter((item: { materialType: any; }) => item.materialType === material.id))
    }

    return (
        <div className="right">
            <YhBox
                title={""}
                style={{
                    width: "286px",
                    height: "690px",
                    marginRight: "20px",
                }}
            >
                <div className="release">
                    <div className="meal">
                        {dayMeal.foods && dayMeal.foods.map((item, index) => (
                            <p key={index} className={`meal-type ${item.id === selectMaterial.id ? 'meal-active' : ''}`} onClick={() => onMaterialType(item, index)}>{item.name}</p>
                        ))}
                    </div>
                </div>
            </YhBox>
            <YhBox
                title={""}
                style={{
                    width: "555px",
                    height: "690px",
                    overflowY: "auto"
                }}
            >
                <div className="food">
                    {tasteList && tasteList.map((item, index) => {
                        return (
                            <Badge count={item.bookingNum} offset={[-16, 3]} key={index}>
                                <div className="food-item" >
                                    <div className="img">
                                        <img className="img-detail" src={getBaseImgLookUrl(item.image as string)} alt={item.name} />
                                    </div>
                                    <div className="message">
                                        <span className="name">{item.name}</span>
                                        <p className="other">
                                            <span>口感：{item.labelName}</span>
                                        </p>
                                    </div>
                                </div>
                            </Badge>
                        )
                    })}
                </div>
            </YhBox>
        </div>
    )
}